const Footer = () => {
    return (
        <div className="footer">
            <p1> Zero Studios 2023 © </p1>
        </div>
        
    )
}

export default Footer;